// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2rARr","modalForm":"UpgradeEpcsModal_modalForm__1xEps","modalFooter":"UpgradeEpcsModal_modalFooter__2f4Uf"};